<template>
  <div class="mfa-introduction">
    <h5 class="title is-5">多要素認証（MFA）の導入方法</h5>
    <section>
      <p>
        Pescleを安全にご利用いただくために、多要素認証によるセキュリティ対策を導入しております。
        アカウント情報を守るために、多要素認証の設定を行っていただきますようお願いいたします。
      </p>
      <img src="./img/introduction/0-1.png" alt="多要素認証の導入説明画像" />
    </section>
    <section class="margin-left">
      <hr />
      <details class="container">
        <summary class="title is-5">多要素認証の導入</summary>
        <div class="steps-container">
          <div class="step">
            <p><strong>(1)</strong> ユーザー情報の確認: Menu⇒Profile</p>
            <img
              src="./img/introduction/1-1.png"
              alt="ユーザー情報確認の説明画像"
            />
          </div>
          <div class="step">
            <p>
              <strong>(2)</strong> 多要素認証設定:
              スマートフォンへ認証アプリを導入 (Google認証システム) + 次へ
            </p>
            <img
              src="./img/introduction/2-1.png"
              alt="スマートフォンへ認証アプリを導入の説明画像"
            />
          </div>

          <div class="step">
            <p>
              <strong>(3)</strong> 多要素認証設定: Google認証アプリ Google
              Authenticator(参考)
            </p>
            <img
              src="./img/introduction/3-1.png"
              alt="Google認証アプリの説明画像"
            />
            <br />
            <a
              href="https://apps.apple.com/jp/app/google-authenticator/id388497605"
              target="_blank"
              rel="noopener noreferrer"
              >Google Authenticator App Store</a
            >
          </div>
          <div class="step">
            <p>
              <strong>(4)</strong> スマートフォンの
              <span class="highlight">認証アプリ</span>
              でのQRコード読みとり、確認コード入力
            </p>
            <img src="./img/introduction/4-1.png" alt="認証アプリの説明画像" />
          </div>
          <div class="step">
            <p>
              <strong>(5)</strong>
              スマートフォンの認証アプリでのQRコード読みとり、確認コード入力(操作例)
            </p>
            <table class="operation-table">
              <tr>
                <th>スマートフォンの認証アプリでの操作</th>
                <th>PESCLEでの操作</th>
              </tr>
              <tr>
                <td>
                  <img
                    src="./img/introduction/5-1.png"
                    alt="Image 1"
                    width="700"
                  />
                </td>
                <td>
                  <img
                    src="./img/introduction/5-2.png"
                    alt="Image 2"
                    width="700"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </details>
      <hr />
      <details class="container">
        <summary class="title is-5">多要素認証の解除</summary>
        <div class="steps-container">
          <div class="step">
            <p><strong>(1)</strong> ユーザー情報の確認: Menu⇒Profile</p>
            <img src="./img/disable/1-1.png" alt="MFAの削除手順" />
          </div>
        </div>
      </details>
      <hr />
      <details class="container">
        <summary class="title is-5">スマートフォン機種変更時の移行</summary>
        <div class="steps-container">
          <div class="step">
            <p>
              <strong>(1)</strong> <span class="highlight">旧端末</span>での操作
            </p>
            <img
              src="./img/changeDevice/1-1.png"
              alt="スマートフォン変更旧端末の説明"
            />
          </div>
          <div class="step">
            <p>
              <strong>(2)</strong> <span class="highlight">新端末</span>での操作
            </p>
            <img
              src="./img/changeDevice/2-1.png"
              alt="スマートフォン変更新端末の説明"
            />
          </div>
        </div>
      </details>
      <hr />
    </section>
  </div>
</template>

<style>
.steps-container {
  margin-left: 20px;
}
.step {
  margin-bottom: 20px;
}
.margin-left {
  margin-left: 50px;
}
.highlight {
  color: blue;
}
.operation-table {
  width: 100%;
  border-collapse: collapse;
}
.operation-table th,
.operation-table td {
  border: 2px solid #000;
  padding: 10px;
}
</style>
